<app-dialog-page>
    <app-password-reset-form [error]="error" (resetEvent)="reset($event)"></app-password-reset-form>
</app-dialog-page>
